import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import {
  Family2k7vz7ddyergb as Family,
  Companion_getInstance2jaanzr07h9qp as Companion_getInstance,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_primaryParent1y63p7tb3kpdx as get_primaryParent,
  get_lastName3bf5kvm2i63yd as get_lastName,
  get_firstName3blaveac0mrqf as get_firstName,
  get_shortIdrr7ewqm2hsnc as get_shortId,
  get_address2uhm0456nbriz as get_address,
  get_city182djzl8rp5cw as get_city,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  allTextFieldsContain2y4ctgpgxc740 as allTextFieldsContain,
  textSearchConditionr2nfggw95qef as textSearchCondition,
  searchField2rc6mst1no9ok as searchField,
} from '../components/search.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { StringDeferringConfig2dp4ygunddfnv as StringDeferringConfig } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/StringDeferringConfig.mjs';
import { CsvFormat2d7d3ollhiney as CsvFormat } from '../../../../../../kotlinx-serialization-csv-durable/com/lightningkite/kotlinx/serialization/csv/CsvFormat.mjs';
import {
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_nullable197rfua9r7fsz as get_nullable,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { NewFamilyPageoco5erkooy02 as NewFamilyPage } from './NewFamilyPage.mjs';
import { FamilyDetailPage2yycb034kbs09 as FamilyDetailPage } from './FamilyDetailPage.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  first58ocm7j58k3q as first,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration28gf6ughsr3vf as toDuration,
  toDuration7gy6v749ektt as toDuration_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { debounce3vjzafx7e7d30 as debounce } from '../../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import {
  FamilyFilters3iztb6wnntge7 as FamilyFilters,
  familyFilters2jswyuj6xift1 as familyFilters,
  familyFilterChips2jxmvdjmtxbv5 as familyFilterChips,
} from './FamilyFilters.mjs';
import { And1a3dbpwh0hxmu as And } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  sortSelect2bs9xha2fqnl1 as sortSelect,
  exportButton1ekt3fxzrhh34 as exportButton,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_1,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { get_atBottomStart1iulwjfo1udg3 as get_atBottomStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_1,
  tableRecycler8sos3tuo7qum as tableRecycler,
} from '../components/table.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  Cents__toDouble_impl_mg3etm3dxlfojyivr3o as Cents__toDouble_impl_mg3etm,
  Cents1lsbs5l1tlgw as Cents,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  PhoneNumberSerializer_getInstanceq35z0l42la4e as PhoneNumberSerializer_getInstance,
  PhoneNumber16oapr4wkp1a5 as PhoneNumber,
  EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0 as EmailAddress__hashCode_impl_wizg9y,
  PhoneNumber__hashCode_impl_t98twlqkqzqu7p5mbp as PhoneNumber__hashCode_impl_t98twl,
} from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function FamiliesListPage$SortOption$Companion$_anonymous__ipsomf() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.views.families.FamiliesListPage.SortOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  this_0.ascending_ijynum_k$(get_lastName(get_primaryParent(it)));
  this_0.ascending_ijynum_k$(get_firstName(get_primaryParent(it)));
  var tmp$ret$0 = this_0.build_1k0s4u_k$();
  SortOption_NameAscending_instance = new (SortOption())('NameAscending', 0, 'Name, ascending', tmp$ret$0);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$10 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$10);
  this_1.descending_tl4o2_k$(get_lastName(get_primaryParent(it_0)));
  this_1.descending_tl4o2_k$(get_firstName(get_primaryParent(it_0)));
  var tmp$ret$6 = this_1.build_1k0s4u_k$();
  SortOption_NameDescending_instance = new (SortOption())('NameDescending', 1, 'Name, descending', tmp$ret$6);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$16 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$16);
  this_2.ascending_ijynum_k$(get_shortId(it_1));
  var tmp$ret$12 = this_2.build_1k0s4u_k$();
  SortOption_FidAscending_instance = new (SortOption())('FidAscending', 2, 'FID, ascending', tmp$ret$12);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_3 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$22 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$22);
  this_3.descending_tl4o2_k$(get_shortId(it_2));
  var tmp$ret$18 = this_3.build_1k0s4u_k$();
  SortOption_FidDescending_instance = new (SortOption())('FidDescending', 3, 'FID, descending', tmp$ret$18);
  // Inline function 'com.lightningkite.services.database.sort' call
  // Inline function 'kotlin.apply' call
  var this_4 = new (SortBuilder())();
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(Family()), arrayOf([]), false));
  var tmp$ret$28 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$28);
  this_4.ascending_ijynum_k$(get_city(get_address(it_3)));
  this_4.ascending_ijynum_k$(get_lastName(get_primaryParent(it_3)));
  var tmp$ret$24 = this_4.build_1k0s4u_k$();
  SortOption_City_instance = new (SortOption())('City', 4, 'City', tmp$ret$24);
  if (Companion_instance_2 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var SortOption_NameAscending_instance;
var SortOption_NameDescending_instance;
var SortOption_FidAscending_instance;
var SortOption_FidDescending_instance;
var SortOption_City_instance;
function values() {
  static_init();
  return [SortOption_NameAscending_getInstance(), SortOption_NameDescending_getInstance(), SortOption_FidAscending_getInstance(), SortOption_FidDescending_getInstance(), SortOption_City_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, FamiliesListPage$SortOption$Companion$_anonymous__ipsomf);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  static_init();
  return Companion_instance_2;
}
var $ENTRIES;
var SortOptionClass;
function SortOption() {
  if (SortOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName, sort) {
        super(name, ordinal);
        this.displayName_1 = displayName;
        this.sort_1 = sort;
      }
    }
    initMetadataForClass($, 'SortOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    SortOptionClass = $;
  }
  return SortOptionClass;
}
function FamiliesListPage$_get_title_$lambda_kn2v09($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyListTitle_7vfhpp_k$();
}
function FamiliesListPage$condition$lambda$lambda(word) {
  return allTextFieldsContain(Companion_getInstance().serializer_9w0wvi_k$(), word);
}
function FamiliesListPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyListTitle_7vfhpp_k$();
}
function FamiliesListPage$render$lambda$lambda(it) {
  return it.displayName_1;
}
function FamiliesListPage$render$lambda$slambda(this$0, $this_exportButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance_3;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp_0 = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.condition_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var rows = yield* tmp.fetchAll_w0g153_k$(tmp_0, tmp$ret$1, $completion);
    var csv = (new (CsvFormat())(new (StringDeferringConfig())(EmptySerializersModule(), VOID, ''))).encodeToString_k0apqx_k$(ListSerializer(Companion_instance_3.serializer_9w0wvi_k$()), rows);
    yield* download($this_exportButton.get_context_h02k06_k$(), 'families.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function FamiliesListPage$render$lambda_0($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function FamiliesListPage$render$lambda_1($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyAddFamilyButton_qgzmly_k$();
}
function FamiliesListPage$render$lambda_2($this$addButton) {
  $this$addButton.set_action_2ds022_k$(Action('Add family', VOID, VOID, VOID, VOID, VOID, FamiliesListPage$render$lambda$slambda_0($this$addButton)));
  return Unit_instance;
}
function FamiliesListPage$render$lambda$slambda_0($this_addButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($this_addButton.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (NewFamilyPage())());
    return Unit_instance;
  }), 1);
}
function FamiliesListPage$render$lambda_3(it) {
  return new (FamilyDetailPage())(it._id_1);
}
function FamiliesListPage$render$lambda_4($this$text) {
  return 'FID';
}
function FamiliesListPage$render$lambda_5($this$text, it) {
  return it.shortId_1;
}
function FamiliesListPage$render$lambda_6($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyColumnLabel_vxra7j_k$();
}
function FamiliesListPage$render$lambda_7($this$text, it) {
  return it.get_distinctName_5wyy9c_k$();
}
function FamiliesListPage$render$lambda_8($this$text) {
  return 'Children';
}
function FamiliesListPage$render$lambda_9($this$text, it) {
  return joinToString(it.childNames_1, ' \u2022 ');
}
function FamiliesListPage$render$lambda_10($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyCityColumnLabel_bqfeje_k$();
}
function FamiliesListPage$render$lambda_11($this$text, it) {
  return it.address_1.toCityState_srlsgl_k$();
}
function FamiliesListPage$render$lambda_12($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
function SortOption_NameAscending_getInstance() {
  static_init();
  return SortOption_NameAscending_instance;
}
function SortOption_NameDescending_getInstance() {
  static_init();
  return SortOption_NameDescending_instance;
}
function SortOption_FidAscending_getInstance() {
  static_init();
  return SortOption_FidAscending_instance;
}
function SortOption_FidDescending_getInstance() {
  static_init();
  return SortOption_FidDescending_instance;
}
function SortOption_City_getInstance() {
  static_init();
  return SortOption_City_instance;
}
var FamiliesListPageClass;
function FamiliesListPage() {
  if (FamiliesListPageClass === VOID) {
    class $ {
      constructor() {
        this.textSearch_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_0();
        var tmp$ret$0 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        tmp.debouncedTextSearch_1 = debounce(this.textSearch_1, tmp$ret$0, get_AppScope());
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(new (FamilyFilters())());
        var tmp_0 = this;
        tmp_0.condition_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(this.debouncedTextSearch_1);
          return And().new_com_lightningkite_services_database_Condition_And_ln02sz_k$([textSearchCondition(tmp, FamiliesListPage$condition$lambda$lambda), $this$remember.invoke_r7m7el_k$(this.filter_1).toCondition_oj74tc_k$()]);
        });
        this.sort_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(first(get_entries()));
        var tmp_1 = this;
        tmp_1.data_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$();
          var tmp_0 = new (Query())($this$remember.invoke_r7m7el_k$(this.condition_1), $this$remember.invoke_r7m7el_k$(this.sort_1).sort_1, VOID, 50);
          // Inline function 'kotlin.time.Companion.minutes' call
          Companion_getInstance_0();
          var tmp$ret$1 = toDuration_0(5, DurationUnit_MINUTES_getInstance());
          return tmp.list$default_sjz00l_k$(tmp_0, VOID, tmp$ret$1);
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, FamiliesListPage$_get_title_$lambda_kn2v09);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_1().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = themed(element, CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        this_2.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = get_atBottomStart(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, FamiliesListPage$render$lambda);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_4 = weight(element_0, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Space())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        searchField(element_0, this.textSearch_1);
        sortSelect(element_0, ($this$sortSelect) => {
          var tmp = _Constant___init__impl__v45mub(toList(get_entries()));
          $this$sortSelect.bind_64a41i_k$(this.sort_1, new (Constant())(tmp), FamiliesListPage$render$lambda$lambda);
          return Unit_instance;
        });
        familyFilters(element_0, this.filter_1);
        exportButton(element_0, ($this$exportButton) => {
          $this$exportButton.set_action_2ds022_k$(Action('Export families', VOID, VOID, VOID, VOID, VOID, FamiliesListPage$render$lambda$slambda(this, $this$exportButton)));
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_5 = shownWhen(element_0, false, VOID, FamiliesListPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Separator())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var tmp_2 = themed(element_3, ImportantSemantic_getInstance());
        var tmp_3 = FamiliesListPage$render$lambda_1;
        addButton(tmp_2, tmp_3, FamiliesListPage$render$lambda_2);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        element_0.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_0);
        familyFilterChips(element, this.filter_1);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_4 = weight(element, 1.0);
        var tmp_5 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.data_1));
        var tmp_6 = FamiliesListPage$render$lambda_3;
        var tmp_7 = Companion_instance_1;
        var tmp_8 = FamiliesListPage$render$lambda_4;
        var tmp_9 = tmp_7.text_y5ktm4_k$(tmp_8, 0.3, FamiliesListPage$render$lambda_5);
        var tmp_10 = Companion_instance_1;
        var tmp_11 = FamiliesListPage$render$lambda_6;
        var tmp_12 = tmp_10.text$default_gwb2zv_k$(tmp_11, VOID, FamiliesListPage$render$lambda_7);
        var tmp_13 = Companion_instance_1;
        var tmp_14 = FamiliesListPage$render$lambda_8;
        var tmp_15 = tmp_13.text$default_gwb2zv_k$(tmp_14, VOID, FamiliesListPage$render$lambda_9);
        var tmp_16 = Companion_instance_1;
        var tmp_17 = FamiliesListPage$render$lambda_10;
        tableRecycler(tmp_4, tmp_5, tmp_6, [tmp_9, tmp_12, tmp_15, tmp_16.text$default_gwb2zv_k$(tmp_17, VOID, FamiliesListPage$render$lambda_11)]);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_6 = shownWhen(element, VOID, VOID, FamiliesListPage$render$lambda_12);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Space())(this_6.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'FamiliesListPage', FamiliesListPage, VOID, [Page()]);
    FamiliesListPageClass = $;
  }
  return FamiliesListPageClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      *fetchAll_w0g153_k$(api, condition, $completion) {
        var families = yield* api.get_family_d7lffx_k$().query_o986pg_k$(new (Query())(condition, VOID, VOID, 2147483647), $completion);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(families, 10));
        var _iterator__ex2g4s = families.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp = item.get_familyName_6ytaaw_k$();
          var tmp_0 = item.primaryParent_1.get_fullName_9skygt_k$();
          var tmp0_safe_receiver = item.secondaryParent_1;
          var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_fullName_9skygt_k$();
          var tmp1_safe_receiver = item.income_1.min_1;
          var tmp_2;
          var tmp_3 = tmp1_safe_receiver;
          if ((tmp_3 == null ? null : new (Cents())(tmp_3)) == null) {
            tmp_2 = null;
          } else {
            tmp_2 = Cents__toDouble_impl_mg3etm(tmp1_safe_receiver);
          }
          var tmp_4 = tmp_2;
          var tmp2_safe_receiver = item.income_1.max_1;
          var tmp_5;
          var tmp_6 = tmp2_safe_receiver;
          if ((tmp_6 == null ? null : new (Cents())(tmp_6)) == null) {
            tmp_5 = null;
          } else {
            tmp_5 = Cents__toDouble_impl_mg3etm(tmp2_safe_receiver);
          }
          var tmp$ret$2 = new (FamilyCsvRow())(item.shortId_1, tmp, tmp_0, item.primaryParent_1.email_1, item.primaryParent_1.phone_1, tmp_1, tmp_4, tmp_5, item.familySize_1, item.address_1.line1__1, item.address_1.line2__1, item.address_1.city_1, item.address_1.state_1, item.address_1.postalCode_1, item.informationVerifiedAt_1, item.active_1);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return destination;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($, VOID, VOID, [2]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.families.FamilyCsvRow', this, 16);
        tmp0_serialDesc.addElement_5pzumi_k$('fid', false);
        tmp0_serialDesc.addElement_5pzumi_k$('family', false);
        tmp0_serialDesc.addElement_5pzumi_k$('primaryParent', false);
        tmp0_serialDesc.addElement_5pzumi_k$('primaryParentEmail', false);
        tmp0_serialDesc.addElement_5pzumi_k$('primaryParentPhone', false);
        tmp0_serialDesc.addElement_5pzumi_k$('secondaryParent', false);
        tmp0_serialDesc.addElement_5pzumi_k$('incomeMin', false);
        tmp0_serialDesc.addElement_5pzumi_k$('incomeMax', false);
        tmp0_serialDesc.addElement_5pzumi_k$('familySize', false);
        tmp0_serialDesc.addElement_5pzumi_k$('addressLine1', false);
        tmp0_serialDesc.addElement_5pzumi_k$('addressLine2', false);
        tmp0_serialDesc.addElement_5pzumi_k$('city', false);
        tmp0_serialDesc.addElement_5pzumi_k$('state', false);
        tmp0_serialDesc.addElement_5pzumi_k$('postalCode', false);
        tmp0_serialDesc.addElement_5pzumi_k$('informationVerifiedAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('active', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ed7gyf_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.fid_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.family_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 2, value.primaryParent_1);
        var tmp = EmailAddressSerializer_getInstance();
        var tmp_0 = value.primaryParentEmail_1;
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
        var tmp_1 = PhoneNumberSerializer_getInstance();
        var tmp_2 = value.primaryParentPhone_1;
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, tmp_1, tmp_2 == null ? null : new (PhoneNumber())(tmp_2));
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.secondaryParent_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, DoubleSerializer_getInstance(), value.incomeMin_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, DoubleSerializer_getInstance(), value.incomeMax_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, IntSerializer_getInstance(), value.familySize_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 9, value.addressLine1__1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 10, value.addressLine2__1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 11, value.city_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 12, value.state_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 13, value.postalCode_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 14, LocalDateSerializer_getInstance(), value.informationVerifiedAt_1);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 15, value.active_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ed7gyf_k$(encoder, value instanceof FamilyCsvRow() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_local13 = null;
        var tmp18_local14 = null;
        var tmp19_local15 = false;
        var tmp20_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp20_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          var tmp_2 = PhoneNumberSerializer_getInstance();
          var tmp_3 = tmp8_local4;
          var tmp_4 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp_2, tmp_3 == null ? null : new (PhoneNumber())(tmp_3));
          tmp8_local4 = tmp_4 == null ? null : tmp_4.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, IntSerializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
          tmp17_local13 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 13);
          tmp3_bitMask0 = tmp3_bitMask0 | 8192;
          tmp18_local14 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 14, LocalDateSerializer_getInstance(), tmp18_local14);
          tmp3_bitMask0 = tmp3_bitMask0 | 16384;
          tmp19_local15 = tmp20_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 15);
          tmp3_bitMask0 = tmp3_bitMask0 | 32768;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp20_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_5 = EmailAddressSerializer_getInstance();
                var tmp_6 = tmp7_local3;
                var tmp_7 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_5, tmp_6 == null ? null : new (EmailAddress())(tmp_6));
                tmp7_local3 = tmp_7 == null ? null : tmp_7.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                var tmp_8 = PhoneNumberSerializer_getInstance();
                var tmp_9 = tmp8_local4;
                var tmp_10 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, tmp_8, tmp_9 == null ? null : new (PhoneNumber())(tmp_9));
                tmp8_local4 = tmp_10 == null ? null : tmp_10.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, DoubleSerializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, IntSerializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              case 13:
                tmp17_local13 = tmp20_input.decodeStringElement_3oenpg_k$(tmp0_desc, 13);
                tmp3_bitMask0 = tmp3_bitMask0 | 8192;
                break;
              case 14:
                tmp18_local14 = tmp20_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 14, LocalDateSerializer_getInstance(), tmp18_local14);
                tmp3_bitMask0 = tmp3_bitMask0 | 16384;
                break;
              case 15:
                tmp19_local15 = tmp20_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 15);
                tmp3_bitMask0 = tmp3_bitMask0 | 32768;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp20_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FamilyCsvRow().new_org_thecommunitygroupinc_cares_views_families_FamilyCsvRow_kq96pq_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(EmailAddressSerializer_getInstance()), get_nullable(PhoneNumberSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LocalDateSerializer_getInstance()), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var FamilyCsvRowClass;
function FamilyCsvRow() {
  if (FamilyCsvRowClass === VOID) {
    class $ {
      constructor(fid, family, primaryParent, primaryParentEmail, primaryParentPhone, secondaryParent, incomeMin, incomeMax, familySize, addressLine1, addressLine2, city, state, postalCode, informationVerifiedAt, active) {
        this.fid_1 = fid;
        this.family_1 = family;
        this.primaryParent_1 = primaryParent;
        this.primaryParentEmail_1 = primaryParentEmail;
        this.primaryParentPhone_1 = primaryParentPhone;
        this.secondaryParent_1 = secondaryParent;
        this.incomeMin_1 = incomeMin;
        this.incomeMax_1 = incomeMax;
        this.familySize_1 = familySize;
        this.addressLine1__1 = addressLine1;
        this.addressLine2__1 = addressLine2;
        this.city_1 = city;
        this.state_1 = state;
        this.postalCode_1 = postalCode;
        this.informationVerifiedAt_1 = informationVerifiedAt;
        this.active_1 = active;
      }
      toString() {
        var tmp = this.primaryParentEmail_1;
        var tmp_0 = toString(tmp == null ? null : new (EmailAddress())(tmp));
        var tmp_1 = this.primaryParentPhone_1;
        return 'FamilyCsvRow(fid=' + this.fid_1 + ', family=' + this.family_1 + ', primaryParent=' + this.primaryParent_1 + ', primaryParentEmail=' + tmp_0 + ', primaryParentPhone=' + toString(tmp_1 == null ? null : new (PhoneNumber())(tmp_1)) + ', secondaryParent=' + this.secondaryParent_1 + ', incomeMin=' + this.incomeMin_1 + ', incomeMax=' + this.incomeMax_1 + ', familySize=' + this.familySize_1 + ', addressLine1=' + this.addressLine1__1 + ', addressLine2=' + this.addressLine2__1 + ', city=' + this.city_1 + ', state=' + this.state_1 + ', postalCode=' + this.postalCode_1 + ', informationVerifiedAt=' + toString(this.informationVerifiedAt_1) + ', active=' + this.active_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.fid_1);
        result = imul(result, 31) + getStringHashCode(this.family_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.primaryParent_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.primaryParentEmail_1;
        if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = EmailAddress__hashCode_impl_wizg9y(this.primaryParentEmail_1);
        }
        result = tmp + tmp_0 | 0;
        var tmp_2 = imul(result, 31);
        var tmp_3;
        var tmp_4 = this.primaryParentPhone_1;
        if ((tmp_4 == null ? null : new (PhoneNumber())(tmp_4)) == null) {
          tmp_3 = 0;
        } else {
          tmp_3 = PhoneNumber__hashCode_impl_t98twl(this.primaryParentPhone_1);
        }
        result = tmp_2 + tmp_3 | 0;
        result = imul(result, 31) + (this.secondaryParent_1 == null ? 0 : getStringHashCode(this.secondaryParent_1)) | 0;
        result = imul(result, 31) + (this.incomeMin_1 == null ? 0 : getNumberHashCode(this.incomeMin_1)) | 0;
        result = imul(result, 31) + (this.incomeMax_1 == null ? 0 : getNumberHashCode(this.incomeMax_1)) | 0;
        result = imul(result, 31) + (this.familySize_1 == null ? 0 : this.familySize_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.addressLine1__1) | 0;
        result = imul(result, 31) + getStringHashCode(this.addressLine2__1) | 0;
        result = imul(result, 31) + getStringHashCode(this.city_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.state_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.postalCode_1) | 0;
        result = imul(result, 31) + (this.informationVerifiedAt_1 == null ? 0 : this.informationVerifiedAt_1.hashCode()) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.active_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FamilyCsvRow()))
          return false;
        if (!(this.fid_1 === other.fid_1))
          return false;
        if (!(this.family_1 === other.family_1))
          return false;
        if (!(this.primaryParent_1 === other.primaryParent_1))
          return false;
        var tmp = this.primaryParentEmail_1;
        var tmp_0 = tmp == null ? null : new (EmailAddress())(tmp);
        var tmp_1 = other.primaryParentEmail_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (EmailAddress())(tmp_1)))
          return false;
        var tmp_2 = this.primaryParentPhone_1;
        var tmp_3 = tmp_2 == null ? null : new (PhoneNumber())(tmp_2);
        var tmp_4 = other.primaryParentPhone_1;
        if (!equals(tmp_3, tmp_4 == null ? null : new (PhoneNumber())(tmp_4)))
          return false;
        if (!(this.secondaryParent_1 == other.secondaryParent_1))
          return false;
        if (!equals(this.incomeMin_1, other.incomeMin_1))
          return false;
        if (!equals(this.incomeMax_1, other.incomeMax_1))
          return false;
        if (!(this.familySize_1 == other.familySize_1))
          return false;
        if (!(this.addressLine1__1 === other.addressLine1__1))
          return false;
        if (!(this.addressLine2__1 === other.addressLine2__1))
          return false;
        if (!(this.city_1 === other.city_1))
          return false;
        if (!(this.state_1 === other.state_1))
          return false;
        if (!(this.postalCode_1 === other.postalCode_1))
          return false;
        if (!equals(this.informationVerifiedAt_1, other.informationVerifiedAt_1))
          return false;
        if (!(this.active_1 === other.active_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_families_FamilyCsvRow_kq96pq_k$(seen0, fid, family, primaryParent, primaryParentEmail, primaryParentPhone, secondaryParent, incomeMin, incomeMax, familySize, addressLine1, addressLine2, city, state, postalCode, informationVerifiedAt, active, serializationConstructorMarker) {
        if (!(65535 === (65535 & seen0))) {
          throwMissingFieldException(seen0, 65535, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.fid_1 = fid;
        $this.family_1 = family;
        $this.primaryParent_1 = primaryParent;
        $this.primaryParentEmail_1 = primaryParentEmail;
        $this.primaryParentPhone_1 = primaryParentPhone;
        $this.secondaryParent_1 = secondaryParent;
        $this.incomeMin_1 = incomeMin;
        $this.incomeMax_1 = incomeMax;
        $this.familySize_1 = familySize;
        $this.addressLine1__1 = addressLine1;
        $this.addressLine2__1 = addressLine2;
        $this.city_1 = city;
        $this.state_1 = state;
        $this.postalCode_1 = postalCode;
        $this.informationVerifiedAt_1 = informationVerifiedAt;
        $this.active_1 = active;
        return $this;
      }
    }
    initMetadataForClass($, 'FamilyCsvRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    FamilyCsvRowClass = $;
  }
  return FamilyCsvRowClass;
}
//region block: init
Companion_instance_3 = new (Companion_0())();
//endregion
//region block: exports
export {
  SortOption as SortOption3rzy1xty7kmz2,
  FamiliesListPage as FamiliesListPage2r5h75kkdixvz,
};
//endregion

//# sourceMappingURL=FamilyListPage.mjs.map
